import React, { useEffect, useMemo, useRef, useState } from "react";
import CloseX from "../../_icons/CloseX";
import TickIcon from "../../_icons/TickIcon";
import Popover from "../../_commons/Popover";
import SkeletonLoader from "../SkeletonLoader";

const EntityCell = ({
	children,
	customContent = false,
	customToolTip = false,
	renderToolTip,
	value,
	classes = "", //  true-state || false-state || empty-state
	styles = {},
	loading = false,
	error = false,
	hideTooltip = false,
	handleCellClick = () => {},
	...rest
}) => {
	const stringValue = useMemo(() => JSON.stringify(value), [value]);
	const [hover, setHover] = useState(false);

	const time = 200;
	const timerRef = useRef();
	const handleStatus = (cond) => {
		clearTimeout(timerRef.current);
		timerRef.current = setTimeout(() => {
			setHover(cond);
		}, time);
	};
	useEffect(() => {
		return () => {
			if (timerRef.current) {
				clearTimeout(timerRef.current);
			}
		};
	}, []);

	const renderPopover = (data, rest) => {
		const value = typeof data == "object" ? JSON.stringify(data) : data;
		return (
			<div
				onMouseEnter={() => handleStatus(true)}
				onMouseLeave={() => handleStatus(false)}
				className="entity-cell-tooltip-description"
			>
				{customToolTip ? <> {renderToolTip(data, rest, hover)}</> : value}
			</div>
		);
	};
	return (
		<Popover
			position="center"
			tooltipPosition="center"
			data={stringValue}
			renderPopover={renderPopover}
			showOnHover={!hideTooltip}
			classes={`entity-cell-tooltip ${loading ? "loading" : error ? "error" : ""} 
			   ${!loading && !error && hover ? "hover-btn" : ""}`}
			time={time}
			{...rest}
		>
			<div
				onMouseEnter={() => handleStatus(true)}
				onMouseLeave={() => handleStatus(false)}
				className={`entity-cell ${loading ? "loading" : error ? "error" : classes}  `}
				style={{ styles }}
				onClick={() => !loading && !error && handleCellClick(value, rest)}
			>
				{loading || error ? (
					<SkeletonLoader classname={"cell-loading"} />
				) : customContent ? (
					<div className="custom-cell">{children}</div>
				) : (
					<>
						<div className="status-icon">
							{stringValue === "true" && <TickIcon fill={hover ? "#0B6E1B" : "#8A8A8A"} />}
							{stringValue === "false" && <CloseX />}
							{stringValue !== "true" && stringValue !== "false" && <div className="dash">-</div>}
						</div>
					</>
				)}
			</div>
		</Popover>
	);
};

export default EntityCell;
